const splitTextByOffset = (textNode, offset) => {
  const leftText = textNode.nodeValue.substring(0, offset);
  const rightText = textNode.nodeValue.substring(offset);

  return [leftText, rightText];
};

export default splitTextByOffset;
